import { type UseQueryResult } from "@tanstack/react-query";
import { Pagination } from "pagination";
import React from "react";

interface Props {
  page: number
  onPageChanged: (page: number) => void
  query: UseQueryResult<server.dto.ApiResponseWrapper<unknown>, unknown>
}

const QueryPagination = (props: Props) => {
  if (props.query.data == null) return null;

  return <Pagination
    noInitialPagination
    paginationData={props.query.data.pagination}
    onPaginate={props.onPageChanged}
  />;
};

export default QueryPagination;